import { Box, Paper, TextField } from '@mui/material';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';
import Typography from '@/shared/ui/typography/Text';

const MIN_YEARS = 1;
const MAX_YEARS = 25;
export const DEFAULT_SEASONAL_YEARS = '3';

export const SelectSeasonalRange = () => {
  const { form } = useAppForm();
  return (
    <form.Field
      children={field => (
        <Box
          component={Paper}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            width: '100%',
            gap: 1
          }}
        >
          <Typography
            size={14}
            sx={{ fontWeight: 700 }}
          >
            Time range
          </Typography>
          <Typography
            size={12}
            sx={{ fontWeight: 500, color: 'gx.textDisabled', mb: 1 }}
          >
            Select the number of years to show in the chart
          </Typography>
          <TextField
            id='seasonalPeriodSelect'
            onChange={e => {
              const raw = Number.parseInt(e.target.value, 10);
              if (!Number.isNaN(raw)) {
                field.handleChange(String(Math.min(MAX_YEARS, Math.max(MIN_YEARS, raw))));
              }
            }}
            size='small'
            slotProps={{ htmlInput: { min: MIN_YEARS, max: MAX_YEARS } }}
            sx={{ width: 100 }}
            type='number'
            value={field.state.value}
          />
        </Box>
      )}
      name='from'
    />
  );
};
